import React, { useState, useEffect } from 'react'
import { Layout, Flex, Tabs } from 'antd';
import MyHeaderOne from '../header';
import MyFooter from '../footer';
import style from './page.module.less'
import axios from 'axios';
import { REQUEST_URL } from '../../utils/env';

const { Header, Footer, Content } = Layout;

export default function About() {

    const [tabItem, setTabItem] = useState([])
    const [aboutInfo, setAboutInfo] = useState()
    const [showInfo, setShowInfo] = useState('')

    const getAbout = async () => {
        try {
            await axios.get(
                REQUEST_URL + '/info/getAbout',
            ).then((Response) => {
                setAboutInfo(Response.data.data)
                setTabItem(Response.data.data.map((item) => {
                    return { 'key': item.id, 'label': item.name }
                }))
                setShowInfo(Response.data.data[0].html)
            })
        } catch (error) {
            throw new Error(error)
        }
    }

    const tabChange = (key) => {
        console.log(key)
        console.log(aboutInfo)
        console.log(aboutInfo.filter((item) => (item.id === key)))
        setShowInfo(aboutInfo.filter((item) => (item.id === key))[0].html)
    }

    useEffect(() => {
        getAbout()
    }, [])

    return (
        <Layout className={style.about}>
            <Header className={style.about__header}>
                <MyHeaderOne />
            </Header>
            <Content className={style.about__wapper}>
                <Flex vertical={true} className={style.about__wapper__one} align='center'>
                    <Flex className={style.about__wapper__one__title}>关于我们</Flex>
                </Flex>
                <Flex vertical={false} align='start' className={style.about__wapper__two}>
                    <Flex className={style.about__wapper__two__left}>
                        <Tabs onChange={tabChange}
                            tabPosition={'left'}
                            items={tabItem}
                        />
                    </Flex>
                    <Flex vertical={true} className={style.about__wapper__two__right}>
                        <Flex vertical={true} className={style.about__wapper__two__right__content}>
                            {/* <Flex className={style.about__wapper__two__right__content__title}>
                                关于科技期刊出版智库
                            </Flex> */}
                            <Flex dangerouslySetInnerHTML={{ __html: showInfo }} vertical={true} className={style.about__wapper__two__right__content__info}>
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>
            </Content>
            <Footer className={style.about__footer}>
                <MyFooter />
            </Footer>
        </Layout >
    )
}
